import axios from 'axios';
import { formatPhone } from 'utils/helper';

type PatientAppointmentChangeBlockedResponse = {
  code: 'patient_appointment_change_blocked';
  reason: 'cutoff_reached' | 'appointment_started';
  message: string;
  cutoffHours?: number | null;
  organizationName: string;
  organizationPhoneNumber?: string | null;
};

function isPatientAppointmentChangeBlockedResponse(
  value: unknown,
): value is PatientAppointmentChangeBlockedResponse {
  if (typeof value !== 'object' || value === null) return false;

  const response = value as Partial<PatientAppointmentChangeBlockedResponse>;
  return response.code === 'patient_appointment_change_blocked'
    && (response.reason === 'cutoff_reached' || response.reason === 'appointment_started')
    && typeof response.message === 'string';
}

export function getPatientAppointmentChangeBlockedMessage(error: unknown): string | null {
  if (!axios.isAxiosError(error) || error.response?.status !== 409) return null;
  if (!isPatientAppointmentChangeBlockedResponse(error.response.data)) return null;

  const response = error.response.data;
  if (!response.organizationPhoneNumber) return response.message;

  const formattedPhone = formatPhone(response.organizationPhoneNumber);
  return formattedPhone === '--'
    ? response.message
    : `${response.message} Call ${formattedPhone}.`;
}
